/* eslint-disable operator-linebreak */
import { Dispatch } from 'redux';
import { ICompany } from 'src/interfaces';

import companiesService from 'src/services/companies.service';

import { CompaniesActionType } from '../action-types';
import { CompaniesAction } from '../actions';

export const getCompanies = () => async (dispatch: Dispatch<CompaniesAction>) => {
  dispatch({
    type: CompaniesActionType.GET_COMPANIES,
  });

  try {
    const { data }: { data: ICompany[] } = await companiesService.getCompanies();

    dispatch({
      type: CompaniesActionType.GET_COMPANIES_SUCCESS,
      payload: { companies: data },
    });
  } catch (err: any) {
    dispatch({
      type: CompaniesActionType.GET_COMPANIES_FAILURE,
      payload: err.message,
    });
  }
};
